module.exports = __webpack_public_path__ + "static/media/chat05.c41c88e5.svg";